module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('ul', {
    staticClass: "quickMenu",
    class: {
      'quickMenu-direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/deposit'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/quick-menu/deposit.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('deposit_funds').tTitle()))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/withdraw'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/quick-menu/withdraw.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('withdraw_funds').tTitle()))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/internal-transfer'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/quick-menu/internal-transfer.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('internal_transfer').tTitle()))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/payment-history'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/quick-menu/payment-history.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('payment_history').tTitle()))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/my-cards'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/quick-menu/mycards.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('my_cards').tTitle()))])])], 1), _vm._v(" "), (_vm.IsLive && _vm.BonusConfig.depositBonus.enabled) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/my-bonuses'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/quick-menu/bonus.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('my_bonuses').tTitle()))])])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f72a22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/FinanceMenu.vue
// module id = 719
// module chunks = 0